import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", "/admin");
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => navigate("/admin", { replace: true, state: { user: r.data } }))
      .catch((e) => navigate("/admin", { replace: true, state: { denied: e?.response?.status === 403 } }));
  }, [location.hash, navigate]);

  return <div className="min-h-screen bg-[#0B0A08]" />;
};
